import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Fires a GA4 page_view event on every client-side route change so the
// GA4 property (loaded from public/index.html) sees SPA navigations.
export default function GAListener() {
    const { pathname, search } = useLocation();
    useEffect(() => {
        if (typeof window.gtag !== "function") return;
        window.gtag("event", "page_view", {
            page_path: pathname + search,
            page_location: window.location.href,
            page_title: document.title,
        });
    }, [pathname, search]);
    return null;
}
